import leadSurvey from '@portalterreno/nextjs-client/portalterreno/redux/slices/leadSurvey';
import { configureStore, Store } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import createSagaMiddleware, { Task } from 'redux-saga';

import user from './reducers/user';
import sagas from './sagas';
import contactForm from './slices/contactForm';
import leadMagnetForm from './slices/leadMagnetForm';
import multipleLeads from './slices/multipleLeads';
import reportForm from './slices/reportForm';
import showPhoneForm from './slices/showPhoneForm';

export interface SagaStore extends Store {
  sagaTask: Task;
}

const makeStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: {
      contactForm,
      leadMagnetForm,
      leadSurvey,
      multipleLeads,
      reportForm,
      showPhoneForm,
      user
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production'
  });
  (store as SagaStore).sagaTask = sagaMiddleware.run(sagas);

  return store;
};

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<typeof store.getState>;

export const wrapper = createWrapper<AppStore>(makeStore);
